import { createContext } from 'react';
import NoSleep from 'nosleep.js';
import { InsomniaOriginal  } from '@awesome-cordova-plugins/insomnia';

const NoSleepContext = createContext<NoSleep| InsomniaOriginal | null>(null);

export default NoSleepContext;